import qs from 'qs';

export const parseQuery = (search) => {
  return qs.parse(search.substring(1));
};
